import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import {
  fetchParameter,
  fetchParameter2,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";
import { UserTab } from "./UserTab";
import { RoleTab } from "./RoleTab";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchRole,
  fetchRoleModal,
  resetData,
  resetTab,
  selectDefaultTab,
  setDefaultTab,
  setPermissionRole,
  setPermissionUserProfile,
} from "./userSlice";
import { fetchOffice } from "../office/officeSlice";
import { fetchMenuTab, selectMenuTab, selectLoading } from "../menu/menuSlice";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { checkMenu } from "../../utility";
import { fetchCountryAll } from "../location/locationSlice";
import { useLocation } from "react-router";

export const UserPage = () => {
  const dispatch = useDispatch();
  const [active, setActive] = useState("");
  const dataMenuTab = useSelector(selectMenuTab);
  const [list, setList] = useState(null);
  const loading = useSelector(selectLoading);
  const defaultTab = useSelector(selectDefaultTab);

  const location = useLocation();

  console.log(location, "location");
  console.log(active, "active");

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      // await dispatch(resetData());

      if (location.pathname === "/administration/management-user/user") {
        console.log("masuk");
        setActive("User Profile");
      }

      await dispatch(
        fetchMenuTab({
          menu_url: "/administration/management-user",
        })
      );

      await dispatch(
        fetchCountryAll({
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter2({
          paramgroup_code: "PHONETYPE",
          pageNo: 1,
          pageSize: -1,
        })
      );

      await dispatch(
        fetchOffice({
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchRoleModal({
          pageNo: 1,
          pageSize: -1,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataMenuTab.length > 0) {
      const data = dataMenuTab.map((item) => item.menu_name);
      setList(data);

      if (location.pathname === "/administration/management-user/user") {
        setActive("User Profile");
      } else if (location.pathname === "/administration/management-user/role") {
        setActive("Role Management");
      } else {
        setActive(data[0]);
      }
      // dispatch(setDefaultTab(data[0]));
      const master = dataMenuTab.map((item, index) => {
        if (item.menu_name === "Role Management") {
          return dispatch(setPermissionRole(item.permissions));
        }
        if (item.menu_name === "User Profile") {
          return dispatch(setPermissionUserProfile(item.permissions));
        }
      });
    }
  }, [dataMenuTab]);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      {list && (
        <div>
          <Tabs
            id="uncontrolled-tab-example"
            activeKey={active}
            onSelect={(e) => {
              setActive(e);
              // dispatch(setDefaultTab(e));
            }}
          >
            {checkMenu(list, "Role Management") && (
              <Tab eventKey="Role Management" title="Role Management">
                <RoleTab active={active} />
              </Tab>
            )}

            {checkMenu(list, "User Profile") && (
              <Tab eventKey="User Profile" title="User Profile">
                <UserTab active={active} setActive={setActive} />
              </Tab>
            )}
          </Tabs>
        </div>
      )}
    </>
  );
};
